var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0832 7.49935C12.0832 8.64993 11.1504 9.58268 9.99984 9.58268C8.84925 9.58268 7.9165 8.64993 7.9165 7.49935C7.9165 6.34876 8.84925 5.41602 9.99984 5.41602C11.1504 5.41602 12.0832 6.34876 12.0832 7.49935Z",
    stroke: "#FF4444",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0477 14.5773C10.7666 14.848 10.3909 14.9993 10 14.9993C9.609 14.9993 9.23334 14.848 8.95225 14.5773C6.37842 12.0833 2.92916 9.29727 4.61126 5.25246C5.52075 3.06545 7.70395 1.66602 10 1.66602C12.296 1.66602 14.4792 3.06546 15.3887 5.25246C17.0687 9.29218 13.6278 12.0919 11.0477 14.5773Z",
    stroke: "#FF4444",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.666C15 17.5865 12.7614 18.3327 10 18.3327C7.23857 18.3327 5 17.5865 5 16.666",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAddress);
export default __webpack_public_path__ + "static/media/home-address.5751f29b7191e0aa82f6c2eab051183c.svg";
export { ForwardRef as ReactComponent };